import type { CommonStrings } from "../../types";

export const common: CommonStrings = {
  nav: {
    blog: "Blog",
    github: "GitHub",
    productHunt: "Product Hunt",
  },
  footer: {
    blog: "Blog",
    privacy: "Privacidad",
    impressum: "Impressum",
    github: "GitHub",
  },
  aria: {
    themeToLight: "Cambiar al modo claro",
    themeToDark: "Cambiar al modo oscuro",
    prevTheme: "Tema anterior",
    nextTheme: "Tema siguiente",
    language: "Cambiar idioma",
  },
};
